import React from 'react';

// ============== SVG DOODLES ==============
export function DoodleStar({ className = "", size = 24, color = "#FFC8DD" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 2L14.5 9H22L16 13.5L18 21L12 17L6 21L8 13.5L2 9H9.5L12 2Z" stroke={color} strokeWidth="2" fill={color} opacity="0.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function DoodleHeart({ className = "", size = 24, color = "#FF6B6B" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 21C12 21 3 14 3 8.5C3 5.42 5.42 3 8.5 3C10.24 3 11.91 3.81 12 5C12.09 3.81 13.76 3 15.5 3C18.58 3 21 5.42 21 8.5C21 14 12 21 12 21Z" stroke={color} strokeWidth="1.5" fill={color} opacity="0.5" strokeLinecap="round"/>
    </svg>
  );
}

export function DoodleSpiral({ className = "", size = 32, color = "#CDB4DB" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className}>
      <path d="M16 16C16 14 18 12 20 12C22 12 24 14 24 16C24 20 20 24 16 24C10 24 6 20 6 16C6 10 10 4 16 4C24 4 30 10 30 16" stroke={color} strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.6"/>
    </svg>
  );
}

export function DoodleFlower({ className = "", size = 28, color = "#B9FBC0" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" className={className}>
      <circle cx="14" cy="14" r="3" fill="#FDF0D5" stroke={color} strokeWidth="1.5"/>
      {[0, 72, 144, 216, 288].map(r => (
        <ellipse key={r} cx="14" cy="7" rx="3" ry="4" fill={color} opacity="0.5" transform={`rotate(${r} 14 14)`}/>
      ))}
    </svg>
  );
}

export function DoodleSquiggle({ className = "", width = 80, color = "#A2D2FF" }) {
  return (
    <svg width={width} height="16" viewBox="0 0 80 16" fill="none" className={className}>
      <path d="M2 8C10 2 18 14 26 8C34 2 42 14 50 8C58 2 66 14 74 8" stroke={color} strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.5"/>
    </svg>
  );
}

export function DoodleCloud({ className = "", size = 40, color = "#A2D2FF" }) {
  return (
    <svg width={size} height={size * 0.6} viewBox="0 0 40 24" fill="none" className={className}>
      <path d="M10 20C6 20 3 17 3 14C3 11 5 9 8 8.5C8 5 11 2 15 2C18 2 20.5 3.5 21.5 6C22 5.7 22.5 5.5 23 5.5C26 5.5 28.5 7.5 28.5 10C28.5 10.2 28.5 10.5 28.4 10.7C30.5 11.5 32 13.5 32 16C32 19 29.5 21 27 20H10Z" fill={color} opacity="0.3" stroke={color} strokeWidth="1.5"/>
    </svg>
  );
}

// ============== NEW DOODLES ==============
export function DoodleRainbow({ className = "", size = 50 }) {
  return (
    <svg width={size} height={size * 0.5} viewBox="0 0 50 25" fill="none" className={className}>
      {[
        { r: 22, color: '#FF6B6B' }, { r: 19, color: '#FFC8DD' }, { r: 16, color: '#FDF0D5' },
        { r: 13, color: '#B9FBC0' }, { r: 10, color: '#A2D2FF' }, { r: 7, color: '#CDB4DB' },
      ].map((arc, i) => (
        <path key={i} d={`M${25 - arc.r} 25 A${arc.r} ${arc.r} 0 0 1 ${25 + arc.r} 25`} stroke={arc.color} strokeWidth="2.5" fill="none" opacity="0.5"/>
      ))}
    </svg>
  );
}

export function DoodleButterfly({ className = "", size = 28, color = "#CDB4DB" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" className={className}>
      <ellipse cx="10" cy="10" rx="6" ry="8" fill={color} opacity="0.4" transform="rotate(-20 10 10)"/>
      <ellipse cx="18" cy="10" rx="6" ry="8" fill="#FFC8DD" opacity="0.4" transform="rotate(20 18 10)"/>
      <line x1="14" y1="6" x2="14" y2="22" stroke={color} strokeWidth="1.5" opacity="0.6"/>
      <circle cx="12" cy="5" r="1" fill={color} opacity="0.5"/>
      <circle cx="16" cy="5" r="1" fill="#FFC8DD" opacity="0.5"/>
    </svg>
  );
}

export function DoodleNote({ className = "", size = 24, color = "#FDF0D5" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 3C12 3 8 8 8 12C8 16 12 21 12 21" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
      <circle cx="8" cy="12" r="4" fill={color} opacity="0.4"/>
      <path d="M16 6L18 2" stroke={color} strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
      <path d="M16 10L19 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    </svg>
  );
}

export function DoodleLeaf({ className = "", size = 24, color = "#B9FBC0" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 22C12 22 4 16 4 10C4 4 12 2 12 2C12 2 20 4 20 10C20 16 12 22 12 22Z" fill={color} opacity="0.4" stroke={color} strokeWidth="1.5"/>
      <path d="M12 22V8" stroke={color} strokeWidth="1" opacity="0.6"/>
      <path d="M12 14L8 10" stroke={color} strokeWidth="1" opacity="0.4"/>
      <path d="M12 12L16 8" stroke={color} strokeWidth="1" opacity="0.4"/>
    </svg>
  );
}

export function DoodlePaw({ className = "", size = 22, color = "#FFC8DD" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" className={className}>
      <ellipse cx="11" cy="14" rx="5" ry="4" fill={color} opacity="0.5"/>
      <circle cx="7" cy="8" r="2.5" fill={color} opacity="0.4"/>
      <circle cx="15" cy="8" r="2.5" fill={color} opacity="0.4"/>
      <circle cx="4" cy="12" r="2" fill={color} opacity="0.4"/>
      <circle cx="18" cy="12" r="2" fill={color} opacity="0.4"/>
    </svg>
  );
}

// ============== DOODLE BORDERS ==============
export function DoodleBorder({ children, className = "", color = "#CDB4DB", style = "dashed" }) {
  return (
    <div className={`relative ${className}`}>
      <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
        border: `3px ${style} ${color}`,
        borderRadius: '1.5rem',
        opacity: 0.5,
      }}>
        <DoodleStar className="absolute -top-2 -left-2" size={16} color={color} />
        <DoodleHeart className="absolute -top-2 -right-2" size={14} color="#FF6B6B" />
        <DoodleFlower className="absolute -bottom-2 -left-2" size={16} color="#B9FBC0" />
        <DoodleStar className="absolute -bottom-2 -right-2" size={14} color="#FDF0D5" />
      </div>
      {children}
    </div>
  );
}

// ============== DOODLE STRIPS ==============
export function DoodleStrip({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-6 opacity-60 ${className}`}>
      <DoodleStar size={18} color="#FFC8DD" />
      <DoodleSquiggle width={60} color="#CDB4DB" />
      <DoodleHeart size={16} color="#FF6B6B" />
      <DoodleSquiggle width={60} color="#A2D2FF" />
      <DoodleFlower size={20} color="#B9FBC0" />
      <DoodleSquiggle width={60} color="#FFC8DD" />
      <DoodleStar size={18} color="#CDB4DB" />
    </div>
  );
}

export function DoodleStripEnhanced({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 opacity-50 ${className}`}>
      <DoodleButterfly size={20} />
      <DoodleSquiggle width={40} color="#FFC8DD" />
      <DoodleRainbow size={30} />
      <DoodleSquiggle width={40} color="#B9FBC0" />
      <DoodlePaw size={18} />
      <DoodleSquiggle width={40} color="#A2D2FF" />
      <DoodleLeaf size={18} />
    </div>
  );
}

// ============== FLOATING DOODLES (ENHANCED) ==============
export function FloatingDoodles({ className = "" }) {
  return (
    <div className={`pointer-events-none fixed inset-0 overflow-hidden z-0 ${className}`}>
      <DoodleStar className="absolute top-[8%] left-[5%] animate-pulse-soft" size={28} color="#FFC8DD" />
      <DoodleHeart className="absolute top-[15%] right-[8%] animate-pulse-soft" size={22} color="#FF6B6B" />
      <DoodleFlower className="absolute top-[40%] left-[3%] animate-pulse-soft" size={32} color="#B9FBC0" />
      <DoodleSpiral className="absolute top-[60%] right-[4%] animate-pulse-soft" size={36} color="#CDB4DB" />
      <DoodleCloud className="absolute top-[75%] left-[10%] animate-pulse-soft" size={44} color="#A2D2FF" />
      <DoodleStar className="absolute bottom-[10%] right-[12%] animate-pulse-soft" size={20} color="#FDF0D5" />
      <DoodleHeart className="absolute top-[30%] right-[20%] animate-pulse-soft" size={16} color="#FFC8DD" />
      <DoodleFlower className="absolute bottom-[25%] left-[18%] animate-pulse-soft" size={24} color="#CDB4DB" />
      {/* New enhanced doodles */}
      <DoodleRainbow className="absolute top-[20%] left-[15%] animate-pulse-soft" size={40} />
      <DoodleButterfly className="absolute top-[50%] right-[15%] animate-pulse-soft" size={26} color="#CDB4DB" />
      <DoodlePaw className="absolute bottom-[35%] right-[25%] animate-pulse-soft" size={20} color="#FFC8DD" />
      <DoodleLeaf className="absolute top-[65%] left-[25%] animate-pulse-soft" size={22} color="#B9FBC0" />
      <DoodleNote className="absolute top-[12%] left-[40%] animate-pulse-soft" size={20} color="#FDF0D5" />
      <DoodleButterfly className="absolute bottom-[15%] left-[35%] animate-pulse-soft" size={22} color="#FFC8DD" />
      <DoodlePaw className="absolute top-[45%] left-[8%] animate-pulse-soft" size={18} color="#CDB4DB" />
    </div>
  );
}
